import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class ScaleApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;

        const data =
            value === CANTRATE_ID
                ? { cantRate: true }
                : {
                      answer: answersActors[0].getSnapshot().context.id,
                      group: value as number,
                  };

        return {
            question: id,
            data: [
                {
                    bool: true,
                    ...data,
                },
            ],
            comment,
        };
    }
}
